import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import http from "services/http";
import illusWarning from "images/illus_warning.png";
import illusSuccess from "images/illus_success.png";
import illusNotEkyc from "images/illus_not_ekyc.png";
import { UpgradeZbaError } from "ztypes/error";
import IconCheck from "icons/icon-check";
import ZJSBridge from "zalo-js-bridge";
import { useRecoilValue } from "recoil";
import { zoomState } from "state";

const UpgradeZba: React.FC<{}> = () => {
  const zoom = useRecoilValue(zoomState);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fid = searchParams.get("fid");
  const [upgradeError, setUpgradeError] = useState<UpgradeZbaError>(
    UpgradeZbaError.SUCCESS
  );
  const [isUpgraded, setIsUpgraded] = useState<boolean>(false);

  const upgradeZba = async () => {
    const resp = await http.upgradeZba(fid);
    setIsUpgraded(true);
    if (resp) {
      setUpgradeError(resp.error_code);
    } else {
      navigate("/nf");
    }
  };
  if (isUpgraded) {
    return (
      <>
        {(() => {
          switch (upgradeError) {
            case UpgradeZbaError.USER_NOT_KYC:
              return (
                <div className="pt-20 px-6 flex flex-col h-screen">
                  <div className="flex flex-col items-center flex-grow self-stretch ">
                    <div className="flex flex-col items-center self-stretch">
                      <img className="w-40 h-40" src={illusNotEkyc} alt="" />
                    </div>
                    <div className="mt-6 flex flex-col items-center">
                      <div className="text-center font-medium text-[18px] leading-[24px]">
                        Vui lòng thực hiện định danh tài khoản Zalo để tiếp tục
                      </div>
                      <div
                        className="mt-1.5 text-center font-normal text-[14px] leading-[18px]"
                        style={{ color: "#6F7071" }}
                      >
                        Bạn cần thực hiện định danh tài khoản theo hướng dẫn,
                        sau đó trở lại bài đăng, nhấn vào nút{" "}
                        <span className="font-medium text-gray-700">
                          Quảng bá
                        </span>{" "}
                        và thực hiện lại các bước.
                      </div>
                    </div>
                    <div
                      className="mt-10 flex px-6 py-3 bg-blue-600 rounded-[100px] font-medium text-[15px] leading-[20px] text-white"
                      onClick={() =>
                        (window.location.href =
                          "https://jp.zaloapp.com/zverify/lp?utm_src=ads_commerce")
                      }
                    >
                      Định danh tài khoản
                    </div>
                  </div>
                </div>
              );
            case UpgradeZbaError.SUCCESS:
              return (
                <div className="pt-20 px-6 flex flex-col h-screen">
                  <div className="flex flex-col items-center flex-grow self-stretch ">
                    <div className="flex flex-col items-center self-stretch">
                      <img className="w-40 h-40" src={illusSuccess} alt="" />
                    </div>
                    <div className="mt-6 flex flex-col items-center">
                      <div className="text-center font-medium text-[18px] leading-[24px]">
                        Nâng cấp thành công
                      </div>
                      <div
                        className="mt-1.5 text-center font-normal text-[14px] leading-[18px]"
                        style={{ color: "#6F7071" }}
                      >
                        Chúc mừng bạn đã đăng ký thành công tài khoản zBusiness
                        Basic
                      </div>
                    </div>
                    <div
                      className="mt-10 flex px-6 py-3 bg-blue-600 rounded-[100px] font-medium text-[15px] leading-[20px] text-white"
                      onClick={() => {
                        navigate(`/lp?fid=${fid}`);
                      }}
                    >
                      Tiếp tục quảng bá bài đăng
                    </div>
                  </div>
                </div>
              );
            default:
              return (
                <div className="pt-20 px-6 flex flex-col h-screen">
                  <div className="flex flex-col items-center flex-grow self-stretch ">
                    <div className="flex flex-col items-center self-stretch">
                      <img className="w-40 h-40" src={illusWarning} alt="" />
                    </div>
                    <div className="mt-6 flex flex-col items-center">
                      <div className="text-center font-medium text-[18px] leading-[24px]">
                        Nâng cấp không thành công
                      </div>
                      <div
                        className="mt-1.5 text-center font-normal text-[14px] leading-[18px]"
                        style={{ color: "#6F7071" }}
                      >
                        Tài khoản của bạn chưa đủ điều kiện để thực hiện việc
                        nâng cấp lên gói zBusiness
                      </div>
                    </div>
                    <div
                      className="mt-10 flex px-6 py-3 bg-blue-600 rounded-[100px] font-medium text-[15px] leading-[20px] text-white"
                      onClick={() => ZJSBridge.H5.closeWebview()}
                    >
                      Đã hiểu
                    </div>
                  </div>
                </div>
              );
          }
        })()}
      </>
    );
  }

  return (
    <>
      <div className="px-6 h-screen flex flex-col items-center self-stretch justify-between text-size-adjust-auto">
        <div className="flex flex-col" style={{ zoom: zoom }}>
          <div className="flex flex-col items-center self-stretch">
            <img
              className="mt-6 short:mt-4 w-32 h-32 short:w-32 short:h-28"
              src="https://res-zalo.zadn.vn/upload/media/2024/5/27/illus_zba_1716800694291_47966.png"
            />
            <div className="mt-6 short:mt-3 flex flex-col items-center self-stretch ">
              <div className="text-center font-medium text-[22px] leading-[26px]">
                Quảng bá bài đăng
              </div>
              <div
                className="mt-4 short:mt-2 text-center font-normal text-[15px] leading-[20px]"
                style={{ color: "#6F7071" }}
              >
                Để quảng bá bài đăng bạn phải đăng ký zBusiness Basic (miễn phí)
              </div>
            </div>
          </div>
          <div
            className="mt-8 short:mt-4 px-4 py-6 rounded-xl flex flex-col"
            style={{ background: "#F7F7F8" }}
          >
            <div
              className="font-semibold text-[15px] leading-[20px]"
              style={{ color: "#3D3D3D" }}
            >
              Đặc quyền của zBusiness Basic
            </div>
            <div className="mt-5 flex flex-col">
              <div className="flex flex-start">
                <IconCheck className="w-4 h-4 mt-[3px]"/>
                <div className="ml-3 font-medium text-[16px] leading-[22px]">
                  Quảng bá bài đăng
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <IconCheck className="w-4 h-4 mt-[3px]"/>
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  Được tạo 1 cộng đồng
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <IconCheck className="w-4 h-4 mt-[3px]"/>
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  3 mẫu tin nhắn nhanh
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <IconCheck className="w-4 h-4 mt-[3px]"/>
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  1 mẫu tin nhắn trả lời tự động
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <IconCheck className="w-4 h-4 mt-[3px]"/>
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  Link liên hệ
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <IconCheck className="w-4 h-4 mt-[3px]"/>
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  Danh mục sản phẩm (catalog)​
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-2 mb-6 flex flex-col items-start self-stretch bg-blue-600 rounded-[100px]" style={{ zoom: zoom }}>
          <button
            className="flex flex-col h-12 py-3 justify-center items-center self-stretch font-medium text-[15px] leading-[20px] text-white"
            onClick={upgradeZba}
          >
            Nâng cấp miễn phí
          </button>
        </div>
      </div>
    </>
  );
};

export default UpgradeZba;
